import styled from 'styled-components';

interface SearchBarProps {
  fullWidth?: boolean;
}

export const SearchBar: any = styled.div<SearchBarProps>`
  display: flex;
  margin: 20px;
  padding: 0 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.searchBar.background};

  &.search-tvl-id {
    margin: 0;
    width: 66%;
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0 0 20px 0;
    max-width: ${({ fullWidth }) => (fullWidth ? '100%' : '400px')};
  }
`;

SearchBar.InputContainer = styled.div`
  width: 100%;
`;

SearchBar.Input = styled.input`
  border: none;
  background: none;
  height: 40px;
  width: 100%;
`;

SearchBar.Icon = styled.img`
  margin-right: 14px;
`;

SearchBar.CloseSearch = styled.img`
  margin-left: 14px;
`;
